import { render, staticRenderFns } from "./PanelProvisionListAdmin.vue?vue&type=template&id=4ac553d6&scoped=true&"
import script from "./PanelProvisionListAdmin.vue?vue&type=script&lang=js&"
export * from "./PanelProvisionListAdmin.vue?vue&type=script&lang=js&"
import style0 from "./PanelProvisionListAdmin.vue?vue&type=style&index=0&id=4ac553d6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac553d6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ac553d6')) {
      api.createRecord('4ac553d6', component.options)
    } else {
      api.reload('4ac553d6', component.options)
    }
    module.hot.accept("./PanelProvisionListAdmin.vue?vue&type=template&id=4ac553d6&scoped=true&", function () {
      api.rerender('4ac553d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelProvisionListAdmin.vue"
export default component.exports